// 'zh-TW' 繁体中文
export default {
  common: {
    city: '香港',
    tips: {
      welcome: '您好，欢迎来到',
      hello: "@:common.tips.welcome @:(common.city)!",
    },
    notsaletip: '您訪問的信息已失效',
    notsaledescription: '若有注冊/購買域名的需求，可訪問新網官網查看',
    notsaleLink: '立即訪問',
    saledescription: '您訪問的域名，正在出售',
    saledescriptionen: 'this domain name is for sale!',
    pricetitle: '限時售價',
    pricewhois: 'Whois信息',
    pricename: '所需費用',
    priceunit: '元',
    buy: '立即購買',
    domaintip1: '海量域名數據',
    domaintip2: '快速安全交易',
    domaintip3: '此域名通過新網平臺售賣',
    domaintip4: '查看更多在售二手域名',
    footertitle: '我們的優勢',
    footerpart1: '品牌信譽',
    footerpart1msg1: '國際知名域名注冊服務供應商',
    footerpart1msg2: '爲千萬級用戶提供服務',
    footerpart2: '連續多年市場排名靠前',
    footerpart2msg1: '老牌服務商',
    footerpart2msg2: '累計域名注冊量超1000萬',
    footerpart3: '豐富的域名服務',
    footerpart3msg1: '域名秒注冊，操作更方便',
    footerpart3msg2: '爲您提供 域名注冊、域名搶注、 一口價 等多種域名服務',
  },
}
